// Données statiques ESS Partners Showcase (SDG, régions, traductions)

export const SDG_DATA = {
  8: { name: "Decent Work", nameFr: "Travail décent", nameAr: "العمل اللائق", color: "#a21942", icon: "💼" },
  9: { name: "Industry & Innovation", nameFr: "Industrie & Innovation", nameAr: "الصناعة والابتكار", color: "#fd6925", icon: "🏭" },
  10: { name: "Reduced Inequalities", nameFr: "Inégalités réduites", nameAr: "الحد من عدم المساواة", color: "#dd1367", icon: "⚖️" },
  11: { name: "Sustainable Cities", nameFr: "Villes durables", nameAr: "مدن مستدامة", color: "#fd9d24", icon: "🏙️" },
  17: { name: "Partnerships", nameFr: "Partenariats", nameAr: "الشراكات", color: "#19486a", icon: "🤝" }
};

// Regions
export const REGIONS = ['GCC', 'Africa', 'UK', 'ASEAN', 'International'];

// Translations
export const TRANSLATIONS = {
  en: {
    heroTitle: "Verified ESS Partners",
    heroSubtitle: "aligned with the UN Sustainable Development Goals",
    heroDescription: "Transparent, traceable, and non-financial recognition of responsible decision-support usage.",
    whyLabel: "Why the ESS Partner Label?",
    whyDescription: "The ESS Partner – ODD Aligned label recognizes organizations that use decision-support services responsibly, contributing to the UN Sustainable Development Goals through transparency and inclusion.",
    partnersTitle: "Labeled Partners",
    partnersDescription: "Verified partners demonstrating ESS principles alignment",
    mapTitle: "Partners Map",
    mapDescription: "Interactive map of all labeled partners worldwide",
    howVerify: "How to Verify?",
    howVerifyDescription: "Each partner has a unique QR code and digital signature. Scan or click to verify authenticity in real-time.",
    verifyButton: "Verify",
    viewPublicPage: "View Public Page",
    legalTitle: "Legal Notice",
    legalText: "This page presents non-financial recognition of partners aligned with ESS principles and the UN SDGs through responsible use of decision-support services. It does not constitute a certification, guarantee, offer, or regulated financial service.",
    contactTitle: "Contact",
    contactText: "For institutional inquiries about the ESS Partner label program",
    active: "Active",
    expiringSoon: "Expiring soon",
    expired: "Expired",
    expiredVerification: "Expired — verification required",
    level: "Level",
    region: "Region",
    validUntil: "Valid until",
    filterByRegion: "Filter by Region",
    filterByODD: "Filter by SDG",
    filterByStatus: "Filter by Status",
    clearFilters: "Clear Filters",
    noResults: "No partners match the selected filters",
    showAll: "Show All"
  },
  fr: {
    heroTitle: "Partenaires ESS Vérifiés",
    heroSubtitle: "alignés avec les Objectifs de Développement Durable de l'ONU",
    heroDescription: "Reconnaissance transparente, traçable et non financière d'un usage responsable des outils d'aide à la décision.",
    whyLabel: "Pourquoi le Label ESS Partner ?",
    whyDescription: "Le label ESS Partner – ODD Aligned reconnaît les organisations qui utilisent les services d'aide à la décision de manière responsable, contribuant aux Objectifs de Développement Durable de l'ONU par la transparence et l'inclusion.",
    partnersTitle: "Partenaires Labellisés",
    partnersDescription: "Partenaires vérifiés démontrant leur alignement avec les principes ESS",
    mapTitle: "Carte des Partenaires",
    mapDescription: "Carte interactive de tous les partenaires labellisés dans le monde",
    howVerify: "Comment Vérifier ?",
    howVerifyDescription: "Chaque partenaire dispose d'un QR code unique et d'une signature numérique. Scannez ou cliquez pour vérifier l'authenticité en temps réel.",
    verifyButton: "Vérifier",
    viewPublicPage: "Page Publique",
    legalTitle: "Mentions Légales",
    legalText: "Cette page présente une reconnaissance non financière de partenaires alignés avec les principes de l'ESS et les ODD via un usage responsable d'outils d'aide à la décision. Elle ne constitue ni une certification, ni une garantie, ni une offre, ni un service financier réglementé.",
    contactTitle: "Contact",
    contactText: "Pour toute demande institutionnelle concernant le programme de label ESS Partner",
    active: "Actif",
    expiringSoon: "Expiration imminente",
    expired: "Expiré",
    expiredVerification: "Expiré — vérification requise",
    level: "Niveau",
    region: "Région",
    validUntil: "Valide jusqu'au",
    filterByRegion: "Filtrer par Région",
    filterByODD: "Filtrer par ODD",
    filterByStatus: "Filtrer par Statut",
    clearFilters: "Effacer les Filtres",
    noResults: "Aucun partenaire ne correspond aux filtres sélectionnés",
    showAll: "Tout Afficher"
  },
  ar: {
    heroTitle: "شركاء ESS المعتمدون",
    heroSubtitle: "المتوافقون مع أهداف التنمية المستدامة للأمم المتحدة",
    heroDescription: "اعتراف شفاف وقابل للتحقق وغير مالي بالاستخدام المسؤول لأدوات دعم اتخاذ القرار.",
    whyLabel: "لماذا شارة ESS Partner؟",
    whyDescription: "تعترف شارة ESS Partner – ODD Aligned بالمنظمات التي تستخدم خدمات دعم القرار بشكل مسؤول، مساهمة في أهداف التنمية المستدامة للأمم المتحدة من خلال الشفافية والشمول.",
    partnersTitle: "الشركاء المعتمدون",
    partnersDescription: "شركاء معتمدون يثبتون التوافق مع مبادئ ESS",
    mapTitle: "خريطة الشركاء",
    mapDescription: "خريطة تفاعلية لجميع الشركاء المعتمدين في جميع أنحاء العالم",
    howVerify: "كيف تتحقق؟",
    howVerifyDescription: "يملك كل شريك رمز QR فريدًا وتوقيعًا رقميًا. امسح أو انقر للتحقق من الأصالة في الوقت الفعلي.",
    verifyButton: "تحقق",
    viewPublicPage: "الصفحة العامة",
    legalTitle: "إشعار قانوني",
    legalText: "تعرض هذه الصفحة اعترافًا غير مالي بشركاء متوافقين مع مبادئ الاقتصاد الاجتماعي والتضامني وأهداف التنمية المستدامة من خلال الاستخدام المسؤول لأدوات دعم اتخاذ القرار. ولا تشكل شهادة أو ضمانًا أو عرضًا أو خدمة مالية خاضعة للتنظيم.",
    contactTitle: "اتصل بنا",
    contactText: "للاستفسارات المؤسسية حول برنامج شارة ESS Partner",
    active: "نشط",
    expiringSoon: "سينتهي قريبًا",
    expired: "منتهي",
    expiredVerification: "منتهي — التحقق مطلوب",
    level: "المستوى",
    region: "المنطقة",
    validUntil: "صالح حتى",
    filterByRegion: "تصفية حسب المنطقة",
    filterByODD: "تصفية حسب ODD",
    filterByStatus: "تصفية حسب الحالة",
    clearFilters: "مسح الفلاتر",
    noResults: "لا يوجد شركاء يطابقون الفلاتر المحددة",
    showAll: "عرض الكل"
  }
};
